const API_BASE = `${process.env.PUBLIC_URL || ''}/backend/api`;

const safeJsonParse = (value, fallback = {}) => {
    if (!value || typeof value !== 'string') {
        return fallback;
    }

    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};

const normalizeImageName = (value, fallback = '') => {
    if (!value) {
        return fallback;
    }

    const trimmed = String(value).trim();
    if (!trimmed) {
        return fallback;
    }

    if (trimmed.includes('/')) {
        const parts = trimmed.split('/');
        return parts[parts.length - 1] || fallback;
    }

    return trimmed;
};

export const fetchPublicModule = async (moduleName) => {
    const response = await fetch(`${API_BASE}/content-list.php?module=${encodeURIComponent(moduleName)}&public=1`, {
        credentials: 'include'
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch ${moduleName}`);
    }

    const data = await response.json();
    if (!data.success || !Array.isArray(data.items)) {
        throw new Error(`Invalid ${moduleName} response`);
    }

    return data.items;
};

export const mapTourItem = (item, index = 0) => {
    const payload = safeJsonParse(item.payload, {});
    const fallbackSlug = `tour-${item.id || index + 1}`;

    return {
        id: item.id || index + 1,
        slug: item.slug || payload.slug || fallbackSlug,
        image: normalizeImageName(item.image, payload.image || 'tour_4_1.jpg'),
        bannerImg: normalizeImageName(payload.bannerImg, normalizeImageName(item.image, 'tour_4_1.jpg')),
        title: item.title || payload.title || 'Tour Package',
        price: item.price || payload.price || 'Call/WhatsApp for Price',
        duration: item.duration || payload.duration || 'Custom Duration',
        overviewOne: payload.overviewOne || item.summary || 'Tour details are available on request.',
        overviewTwo: payload.overviewTwo || 'Please contact us for complete itinerary and customization options.',
        highlights: Array.isArray(payload.highlights) ? payload.highlights : [],
        included: Array.isArray(payload.included) ? payload.included : [],
        excluded: Array.isArray(payload.excluded) ? payload.excluded : [],
        basicInfo: payload.basicInfo || {
            destination: 'Northern Pakistan',
            departure: 'Custom',
            language: 'Urdu & English',
            returnDate: 'As per package',
            departureDate: 'On request',
            guide: 'Professional Guide',
            groupSize: 'Custom'
        },
        itinerary: Array.isArray(payload.itinerary) ? payload.itinerary : [],
        gallery: Array.isArray(payload.gallery) ? payload.gallery : []
    };
};

export const mapBlogItem = (item, index = 0) => {
    const payload = safeJsonParse(item.payload, {});
    const tags = Array.isArray(payload.tags)
        ? payload.tags
        : typeof payload.tags === 'string'
            ? payload.tags.split(',').map((tag) => tag.trim()).filter(Boolean)
            : [];

    return {
        id: item.id || index + 1,
        slug: item.slug || payload.slug || `blog-${item.id || index + 1}`,
        image: normalizeImageName(item.image, payload.image || 'blog-s-1-1.jpg'),
        bannerImg: normalizeImageName(payload.bannerImg, normalizeImageName(item.image, 'blog-s-1-1.jpg')),
        inlineImage: normalizeImageName(payload.inlineImage, 'blog_inner_1.jpg'),
        title: item.title || payload.title || 'Travel Update',
        seoTitle: payload.seoTitle || item.title || 'Travel Update',
        metaDescription: payload.metaDescription || item.summary || 'New travel update from Himolan Peak Adventures.',
        excerpt: item.summary || payload.excerpt || 'Read the latest update from Himolan Peak Adventures.',
        author: payload.author || 'Himolan Peak Adventures Team',
        publishDate: payload.publishDate || '01 January, 2026',
        readTime: payload.readTime || '5 min read',
        category: payload.category || 'Travel Updates',
        location: payload.location || 'Northern Pakistan',
        tags,
        intro: Array.isArray(payload.intro) ? payload.intro : [item.summary || 'Travel update is available.'],
        quote: payload.quote || {
            text: 'Plan smarter, travel better with Himolan Peak Adventures.',
            author: 'Himolan Team'
        },
        sectionHeading: payload.sectionHeading || 'Details',
        sectionParagraphs: Array.isArray(payload.sectionParagraphs) ? payload.sectionParagraphs : [],
        practicalTips: Array.isArray(payload.practicalTips) ? payload.practicalTips : []
    };
};

export const mapPackageItem = (item, index = 0) => {
    const payload = safeJsonParse(item.payload, {});

    return {
        id: item.id || index + 1,
        title: item.title || payload.title || 'Tour Package',
        offerTag: payload.offerTag || 'Package',
        icon: payload.icon || '/assets/img/icon/price_1_1.svg',
        price: item.price || payload.price || 'Call for Price',
        durationLabel: payload.durationLabel || '/Per Person',
        description: item.summary || payload.description || 'Customizable tour package for northern Pakistan.',
        features: Array.isArray(payload.features) ? payload.features : [],
        whatsappText: payload.whatsappText || `Assalam o Alaikum! I am interested in the ${item.title || 'tour'} package.`,
        isPopular: Boolean(payload.isPopular)
    };
};
